import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot, UrlTree } from '@angular/router'
import { Observable } from 'rxjs'
import { TranslateService } from '@ngx-translate/core'
import { CoreService } from './core.service'

export interface CheckDataChanges {
  hasUnsavedDataChanges(): boolean
}

@Injectable({
  providedIn: 'root',
})
export class CanDeactivateGuardService implements CanDeactivate<CheckDataChanges> {
  constructor(
    private readonly translateService: TranslateService,
    private core: CoreService,
  ) {}
  canDeactivate(
    component: CheckDataChanges,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (currentRoute.routeConfig.path === 'purchase-order-checkout' && nextState.url === '/purchase-order-hs') {
      return true
    }
    if (component && typeof component.hasUnsavedDataChanges === 'function' && component.hasUnsavedDataChanges()) {
      const isConfirmed = confirm(this.translateService.instant('unsaved-changes.confirmation'))
      if (isConfirmed) {
        this.core.setPurchaseOrderInProgress(null)
      }
      return isConfirmed
    } else {
      return true
    }
  }
}
